import { useAppTheme } from "@hooks/useAppTheme";
import { Chip } from "react-native-paper";

type Props = {
	scorePercent: number;
};

export const ProethicaTestCompletedBadge = ({ scorePercent }: Props) => {
	const theme = useAppTheme();

	return (
		<Chip
			compact={true}
			textStyle={{
				fontSize: 11,
				fontWeight: "600",
				lineHeight: 14,
				color: theme.palette.success.dark,
			}}
			style={{
				alignSelf: "flex-start",
				height: 28,
				justifyContent: "center",
				backgroundColor: theme.colors.progress.highBackground,
				borderRadius: theme.roundness,
			}}
		>
			{`Completed - ${scorePercent}%`}
		</Chip>
	);
};
